/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WasteReason } from '../../models/waste-reason';

export interface GetWasteReasons$Params {
  workCenterId: number;
}

export function getWasteReasons(http: HttpClient, rootUrl: string, params: GetWasteReasons$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WasteReason>>> {
  const rb = new RequestBuilder(rootUrl, getWasteReasons.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WasteReason>>;
    })
  );
}

getWasteReasons.PATH = '/api/v1/WorkCenter/{workCenterId}/wasteReasons';
